/**
 * Le registre des langues du site : une entrée par langue, tout ce qui en dépend.
 *
 * Ces informations vivaient dans quatre fichiers — la liste des langues
 * servies, les attributs HTML et Open Graph, le libellé et le chemin d'accueil
 * du fil d'Ariane, le texte du <noscript>. Trois de ces listes avaient oublié
 * l'allemand, et rien ne le signalait : le <noscript> d'une page allemande
 * aurait publié le mot « undefined », et son fil d'Ariane une URL terminée par
 * « undefined ».
 *
 * Une seule table rend l'oubli impossible plutôt que détectable : ajouter une
 * langue, c'est ajouter une entrée complète ici, et le reste du site la voit.
 */

export const LANGUAGES = {
    fr: {
        html: "fr",
        // Open Graph veut une locale complète, pas un code de langue.
        ogLocale: "fr_FR",
        home: "/fr",
        homeLabel: "Accueil",
        noscript: "Activez JavaScript pour jouer une partie.",
    },
    en: {
        html: "en",
        // L'anglais du site est britannique, et og:locale décrit le contenu.
        // hreflang, lui, reste « en » sans région : une seule version anglaise
        // existe, elle doit servir les États-Unis comme le Royaume-Uni.
        ogLocale: "en_GB",
        home: "/en",
        homeLabel: "Home",
        noscript: "Enable JavaScript to play a game.",
    },
    de: {
        html: "de",
        ogLocale: "de_DE",
        home: "/de",
        homeLabel: "Startseite",
        noscript: "Aktiviere JavaScript, um zu spielen.",
    },
};

/** Les langues servies, dans l'ordre d'affichage du sélecteur. */
export const SUPPORTED = Object.keys(LANGUAGES);

export const DEFAULT_LANG = "fr";

/**
 * La version servie à qui ne correspond à aucune langue déclarée. L'anglais :
 * le français ne s'adresse qu'à la France, l'anglais est le repli du reste du
 * monde.
 */
export const XDEFAULT_LANG = "en";

/**
 * La langue de l'interface pour un navigateur dont aucune langue n'est servie.
 *
 * La meme que x-default, par construction : un visiteur espagnol qui ouvre un
 * lien de partie recoit la reponse que Google lui donne et que la racine du
 * .com lui donne. Distincte de DEFAULT_LANG, qui est la langue du site — celle
 * des routes sans champ `lang`, et celle du prerendu de /new, qui n'a aucun
 * navigateur a consulter.
 */
export const UI_FALLBACK_LANG = XDEFAULT_LANG;

export const isSupported = (lang) => Object.prototype.hasOwnProperty.call(LANGUAGES, lang);

/** Les données d'une langue, ou celles du français si elle est inconnue. */
export function languageData(lang) {
    return LANGUAGES[lang] || LANGUAGES[DEFAULT_LANG];
}
